import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import UpgradeSnackBar from 'components/common/notification/UpgradeSnackBar';

const IntegrationItem = ({ 
    icon: Icon = null,  // Default to null if no icon provided
    text,
    disabled = false,
    comingSoon = false 
}) => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const handleClick = () => {
        // Always set open to true when clicked
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubscribe = () => {
        handleClose();
        navigate('/dashboard/subscribe');
    };

    return (
        <>
            <Box
                onClick={handleClick}
                sx={{
                    width: '100%',
                    border: '1px solid #00000014',
                    cursor: 'pointer',
                    height: '72px',
                    position: 'relative',
                    borderRadius: '12px',
                    backgroundColor: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0 24px',
                    opacity: (disabled || comingSoon) ? 0.5 : 1,
                    '&:hover': {
                        backgroundColor: '#f7f7f7'
                    }
                }}
            >
                <Box
                    sx={{
                        width: '48px',
                        border: '1px solid #00000014',
                        height: '48px',
                        display: 'flex',
                        minWidth: '48px',
                        minHeight: '48px',
                        alignItems: 'center',
                        borderRadius: '8px',
                        justifyContent: 'center',
                        backgroundColor: '#ffffff',
                        marginRight: '12px'
                    }}
                >
                    {Icon && (typeof Icon === 'function' ? <Icon /> : Icon)}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                        sx={{
                            fontSize: '13px',
                            fontWeight: 600
                        }}
                    >
                        {text}
                    </Typography>
                </Box>
                {comingSoon && (
                    <Box
                        sx={{
                            color: '#ffffff',
                            width: '82px',
                            border: '1px solid #00000014',
                            height: '16px',
                            display: 'flex',
                            fontSize: '8px',
                            alignItems: 'center',
                            fontWeight: 700,
                            borderRadius: '4px',
                            justifyContent: 'center',
                            backgroundColor: '#29AEF8E5',
                            position: 'absolute',
                            top: '8px',
                            right: '8px'
                        }}
                    >
                        COMING SOON
                    </Box>
                )}
            </Box>
            
            <UpgradeSnackBar
    open={open}
    handleClose={handleClose}
    handleSubscribe={handleSubscribe}
    message="Upgrade to Pro or Pro Plus for access to integrations"
/>


        </>
    );
};

export default IntegrationItem;